import React from 'react';

import MapPorts from './MapPorts';
import Merging from 'components/Regions/Merging/Page';
import ByCoordsPage from 'components/Regions/ByCoords/ByCoordsPage';

class MapDashboard extends React.Component {
    render() {
        const {
            area,
            ports,
            togglePort,
            onAreaPathReady,
            showMarkersOnlyInThisArea,
            showView,
            createNewArea,
            onChangeArea,
        } = this.props;
        return (
            <div>
                <div style={{ position: 'relative', width: '100%', height: '79.7vh' }}>

                    <div className={showView === 'map' ? 'paper-block margin-10' : 'hidden'}>
                        <span className='name-block absolute small-name'>Map</span>
                        <MapPorts
                            area={area}
                            togglePort={togglePort}
                            ports={ports}
                            onAreaPathReady={onAreaPathReady}
                            showMarkersOnlyInThisArea={showMarkersOnlyInThisArea}
                        />
                    </div>


                    <div className={ showView === 'merge' ? 'paper-block margin-10' : 'hidden'} style={{ height: '78.5vh', overflow: 'auto' }} >
                        <span className='name-block absolute small-name'>MERGING</span>

                        <Merging
                            area={area}
                            createNewArea={createNewArea}
                        />
                    </div>
                    <div className={ showView === 'addByCoords' ? 'paper-block margin-10' : 'hidden'} style={{ height: '77.8vh', overflow: 'auto' }}>
                        <span className='name-block absolute small-name'>Create/update port by coords</span>

                        <ByCoordsPage
                            area={area}
                            onChangeArea={onChangeArea}
                        />
                    </div>
                </div>

            </div>
        );
    }
}

export default MapDashboard;



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Map/Component.jsx